import React from "react";

function RequireStare() {
  return <div className="red-text">&nbsp;*</div>;
}

export default RequireStare;
